var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWave = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 1920,
  height: 956,
  viewBox: "0 0 1920 956",
  fill: "none",
  style: {
    verticalAlign: "middle"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1957.81 -52.8826V694.38C1732 1016 1241.57 1066.97 985.613 694.38C729.653 321.793 242.187 733 -37.8125 310.571V-52.8826H1957.81Z",
  fill: "url(#paint0_linear_920_8)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_920_8",
  x1: -6000.22,
  y1: 12138.2,
  x2: -3431.99,
  y2: 13399.8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF33CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF971D"
})))));
export default SvgWave;